module.exports = __webpack_public_path__ + "img/B低通锐化1000.1e82b9ba.png";